import { render, staticRenderFns } from "./CardEnvioProcesos.vue?vue&type=template&id=5e1a0b20"
import script from "./CardEnvioProcesos.vue?vue&type=script&lang=js"
export * from "./CardEnvioProcesos.vue?vue&type=script&lang=js"
import style0 from "./CardEnvioProcesos.vue?vue&type=style&index=0&id=5e1a0b20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports